export enum RouteType {
  Road = 'Road',
  Mountain = 'Mountain',
  Sea = 'Sea',
  Race = 'Race',
  Bed = 'Bed',
  Food = 'Food',
  Drink = 'Drink'
}

export const getAssetPathForRouteTypeIcon = (type: RouteType) => {
  return `assets/svg/${type}.svg`;
};
